import styled from 'styled-components';

import Logo from 'components/Logo';
import colors from 'utils/colors';
import device from 'utils/device';

export const Wrapper = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  position: relative;
  height: 80px;
  padding-top: 9px;
  padding-bottom: 9px;
  border-bottom: 1px solid ${colors.darkGrey10};
  background-color: ${colors.white};

  @media ${device.isDesktop} {
    /* justify-content: space-between; */
  }
`;

export const LogoWrapper = styled(Logo)`
  @media ${device.isMobile}, ${device.isTablet} {
    flex-grow: 1;
  }
`;

export const DesktopNavigation = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media ${device.isMobile}, ${device.isTablet} {
    display: none;
  }
`;

export const NavBarWrapper = styled.div`
  margin: 0 42px;
`;

export const LoginButton = styled.div``;

export const MobileNavigation = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${device.isDesktop} {
    display: none;
  }
`;
